import IGuest from "@/models/guests/iguest";
import ISimpleGuest from "@/models/guests/isimple-guest";
import { get, post, put, remove } from "./base-service";

const baseUrl = "guests"

export async function getAllGuests(): Promise<ISimpleGuest[]> {
    const response = await get(`${baseUrl}`);

    return response.json();
}

export async function getGuest(id: number): Promise<IGuest> {
    const response = await get(baseUrl, id);

    return response.json();
}

export async function updateGuest(guest: IGuest): Promise<IGuest> {
    const response = await put(baseUrl, guest);
    
    return response.json();
}

export async function addGuest(guest: IGuest): Promise<IGuest> {
    const response = await post(baseUrl, guest);

    return response.json();
}

export async function deleteGuest(id: number): Promise<boolean> {
    const response = await remove(baseUrl, id);

    return response.json();
}